var model, poet;

model = require('./model');

poet = require('./poet');

require('./render');

poet.on('load', function() {
  model.reset();
  return model.start();
});

window.onresize = function() {
  return model.reset();
};
